/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_TitleInputs */

const en_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Your Rights`)
};

const de_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Ihre Rechte`)
};

const fr_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Vos droits`)
};

const es_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Sus derechos`)
};

const it_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. I tuoi diritti`)
};

const nl_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Uw rechten`)
};

const pl_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Twoje prawa`)
};

const fi_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Oikeutesi`)
};

const da_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Dine rettigheder`)
};

const sv_privacy_rights_title = /** @type {(inputs: Privacy_Rights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Dina rättigheter`)
};

/**
* | output |
* | --- |
* | "4. Your Rights" |
*
* @param {Privacy_Rights_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_title = /** @type {((inputs?: Privacy_Rights_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_title(inputs)
	if (locale === "fr") return fr_privacy_rights_title(inputs)
	if (locale === "es") return es_privacy_rights_title(inputs)
	if (locale === "it") return it_privacy_rights_title(inputs)
	if (locale === "nl") return nl_privacy_rights_title(inputs)
	if (locale === "pl") return pl_privacy_rights_title(inputs)
	if (locale === "fi") return fi_privacy_rights_title(inputs)
	if (locale === "da") return da_privacy_rights_title(inputs)
	if (locale === "sv") return sv_privacy_rights_title(inputs)
	return en_privacy_rights_title(inputs)
});